import { combineReducers } from 'redux';
import { companySettings } from './company-settings';
import { results } from './results';

const benchmarks = combineReducers({
  companySettings,
  results,
});

export { benchmarks };
